import { render, staticRenderFns } from "./WalterIASidePanel.vue?vue&type=template&id=5358ba3a&scoped=true"
import script from "./WalterIASidePanel.vue?vue&type=script&lang=js"
export * from "./WalterIASidePanel.vue?vue&type=script&lang=js"
import style0 from "./WalterIASidePanel.vue?vue&type=style&index=0&id=5358ba3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5358ba3a",
  null
  
)

export default component.exports